"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getExtensionFromFileName_1 = require("./getExtensionFromFileName");
var imageFileExtensions = [
    '.bmp',
    '.gif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.jfif',
    '.dib',
    '.png',
    '.psd',
    '.tiff',
    '.tif',
];
function isImageFile(fileName) {
    var extension = getExtensionFromFileName_1.default(fileName);
    if (extension) {
        return imageFileExtensions.indexOf(extension.toLowerCase()) >= 0;
    }
    return false;
}
exports.default = isImageFile;
//# sourceMappingURL=isImageFile.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-file-common/lib/utils/isImageFile.js
// module id = 1759
// module chunks = 0 1 11 13 24 43 84 100 106 107